import React from "react";
import { Plus } from "lucide-react";

const ProjectPageEmptyState = ({
  isProjectActive = true,
  onCreateNewProject,
  onCreateSampleProject,
  canCreateNewProject = true,
  canCreateSampleProject = true,
}) => {
  const title = isProjectActive
    ? "No Projects Available"
    : "No Inactive Projects Available";

  return (
    <div
      className="flex h-full w-full items-center justify-center sm:p-3 flex-wrap md:flex-nowrap"
      style={{ gap: "24px" }}
    >
      <div
        className="flex flex-col items-center text-center max-w-[755px] max-h-[542px] bg-[#F5F4F4FF]"
        style={{
          width: "100%",
          maxWidth: "720px",
          borderRadius: "12px",
          padding: "12px 14px 14px",
          justifyContent: "flex-start",
        }}
      >
        <div className="m-2 shrink-0 self-stretch w-auto box-border">
          <img
            className="block w-full max-h-[260px] object-contain"
            src={require("../../assets/NoProjectImage.png")}
            alt="Empty State"
          />
        </div>

        <h2
          className="text-gray-900 w-full"
          style={{
            fontSize: "28px",
            fontWeight: 700,
            marginBottom: "8px",
            marginTop: 2,
            lineHeight: "36px",
          }}
        >
          {title}
        </h2>

        <div
          className="text-gray-500 w-full box-border px-0.5"
          style={{
            fontSize: "14px",
            lineHeight: "28px",
            marginBottom: "14px",
            maxWidth: "100%",
          }}
        >
          <p className="m-0 mb-1">
            A project is a collection of related test cases.
          </p>
          {isProjectActive ? (
            <p className="m-0 mb-1">
              Projects organize your testing efforts, track test runs, and
              measure progress.
              <br />
              Get started by{" "}
              <span className="text-[#3D3844FF] font-bold">
                creating a new project
              </span>{" "}
              or use a{" "}
              <span className="text-[#3D3844FF] font-bold">sample project</span>{" "}
              to see it in action.
            </p>
          ) : (
            <p className="m-0 mb-1">
              Projects organize your testing efforts, track test runs, and
              measure progress.
            </p>
          )}
        </div>

        {isProjectActive && (
          <div className="w-full flex flex-wrap gap-3 justify-center sm:flex-nowrap">
            <button
              type="button"
              onClick={onCreateNewProject}
              disabled={!canCreateNewProject}
              className="bg-[#1DD75BFF] hover:bg-[#1AC052FF] disabled:opacity-50 disabled:cursor-not-allowed text-[#0A4D20FF] flex items-center justify-center transition-colors cursor-pointer border-none shadow-sm"
              style={{
                height: "44px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 600,
                gap: "8px",
                padding: "0 16px",
                whiteSpace: "nowrap",
              }}
            >
              <Plus className="w-4 h-4 shrink-0" />
              Create New Project
            </button>

            <button
              type="button"
              onClick={onCreateSampleProject}
              disabled={!canCreateSampleProject}
              className="bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed text-gray-800 flex items-center justify-center transition-colors cursor-pointer border border-gray-300 shadow-sm"
              style={{
                height: "44px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 600,
                gap: "8px",
                padding: "0 16px",
                whiteSpace: "nowrap",
              }}
            >
              Create Sample Project
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectPageEmptyState;
